const routes = {
  index: {
    path: 'index.consult.stat',
    url: '/statistique',
  },
  home: {
    path: 'index.consult.stat.home',
    url: '/accueil',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/stat/routes.js